import type { ProductInfo } from "@expert/contentful";
import { Container, Flex, Text } from "@mantine/core";
import type { JSX } from "react";
import { useEffect } from "react";
import type { EligibilityStatus } from "../../types";
import { SaleProgress } from "../../types";
import { getSalesViewConfig } from "./SaleStatusMap";
import classes from "./SaleView.module.css";

interface SaleViewProps {
    status: EligibilityStatus | SaleProgress;
    planType?: "Home" | "Other";
    onPrimarySaleComplete?: () => void;
    productInfo?: ProductInfo;
}

export function SaleView({
    status,
    planType = "Home",
    onPrimarySaleComplete,
    productInfo,
}: SaleViewProps): JSX.Element {
    const { statusHeader, statusBody, icon } = getSalesViewConfig(status);

    useEffect(() => {
        if (status !== SaleProgress.Success && status !== SaleProgress.Declined) return;

        const timer = setTimeout(() => {
            onPrimarySaleComplete?.();
        }, 5000);

        return () => clearTimeout(timer);
    }, [status, onPrimarySaleComplete]);
    return (
        <Flex className={classes.statusContainer} data-testid="sale-finished-view">
            <Container className={classes.statusIcon}>{icon}</Container>
            <Text className={classes.statusHeader} data-testid="sale-view-status-header">
                {statusHeader}
            </Text>
            <Text className={classes.statusBodyText} data-testid="sale-view-status-body">
                {status === SaleProgress.Success && productInfo?.saleSuccessMessage
                    ? productInfo?.saleSuccessMessage
                    : statusBody(planType)}
            </Text>
        </Flex>
    );
}
